export default function buildEnvLocal () {
  return 'COMMANDFORGE_API_KEY=your-api-key-here'
}
